import { useEffect } from 'react';

import { useTenantContext } from '~providers/TenantProvider';
import { TenantInfo } from '~types/tenant.type';

export type TenantBranding = {
  isWhiteLabel: boolean;
  displayName?: string;
  logoUrl?: string;
  heroLogoUrl?: string;
  heroBackgroundUrl?: string;
  bannerBackgroundUrl?: string;
  supportPhone?: string;
  termsUrl?: string;
  privacyUrl?: string;
};

const CHARGEFUZE_BRANDING: TenantBranding = {
  isWhiteLabel: false,
  logoUrl: '/images/logo-black.svg',
  heroLogoUrl: '/images/logo.svg',
  heroBackgroundUrl: '/images/background.png',
  bannerBackgroundUrl: '/images/banner-background.webp',
  supportPhone: '+1 (213) 928-7320',
  termsUrl:
    process.env.REACT_APP_VIEW_TERMS_URL ??
    'https://www.chargefuze.com/terms-of-service/',
  privacyUrl: 'https://www.chargefuze.com/privacy-policy',
};

export const resolveTenantBranding = (
  tenant: TenantInfo | null,
): TenantBranding => {
  if (!tenant?.isWhiteLabel) {
    return CHARGEFUZE_BRANDING;
  }

  return {
    isWhiteLabel: true,
    displayName: tenant.displayName,
    logoUrl: tenant.brand.logoAssetUrl,
    heroLogoUrl: tenant.brand.logoAssetUrl,
    heroBackgroundUrl: tenant.brand.backgroundAssetUrl,
    bannerBackgroundUrl: tenant.brand.backgroundAssetUrl,
    supportPhone: tenant.support.phone,
    termsUrl: tenant.support.termsUrl,
    privacyUrl: tenant.support.privacyUrl,
  };
};

export const useTenantBranding = (): TenantBranding => {
  const { tenant } = useTenantContext();
  return resolveTenantBranding(tenant);
};

export const useTenantDocumentTitle = () => {
  const { isWhiteLabel, displayName } = useTenantBranding();

  useEffect(() => {
    if (isWhiteLabel && displayName) {
      document.title = `Rental App | ${displayName}`;
    }
  }, [isWhiteLabel, displayName]);
};
